import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {InvestVariation} from "@/common/types/commonTypes.ts"
import {INVEST_FIRST_PAGE} from "@/common/const/constants.ts"

type InitialState = {
   investPage: InvestVariation
}

const initialState: InitialState = {
    investPage: INVEST_FIRST_PAGE
}

const interfaceSlice = createSlice({
    name: 'interface',
    initialState,
    reducers: {
        setInvestPage: (state, action: PayloadAction<InvestVariation>) => {
            state.investPage = action.payload
        }
    },
  selectors: {
    interfaceSelector: state => state,
  }
})

export const {
    setInvestPage
} = interfaceSlice.actions

export const {interfaceSelector} = interfaceSlice.selectors
export const interfaceReducer = interfaceSlice.reducer

